export default __webpack_public_path__ + "static/media/mob_preland_6.1d706c7b.jpg";